<script lang="ts">
  import { distributorIsIntegrated } from "@retailer/services/product_card_service";
  import { get } from "lodash";
  import DistributorLink from "@retailer/svelte/ProductDetails/Components/ProductLineBox/DistributorLink.svelte";
  import DistributorName from "@shared/svelte/Components/ProductLines/DistributorName.svelte";

  import type { DualProductDistributor } from "@shared/types/Distributor";
  import type { ProductCardDistributorInfo, ProductLine } from "@shared/types/ProductLine";

  export let productLine: ProductLine;
  export let clickable: boolean = false;
  export let stateParams: any = {};
  export let extraTooltipClass: string = "";
  export let distributorOverride: { name: string } = null;
  export let clickableTextClass: string = "";
  export let targetObjectType: string = null;

  const productLineDualDistributors: DualProductDistributor[] =
    productLine.dual_product_distributors || [];

  // Distributor PLP - should hide distributor name
  const hideDistributor: boolean = (stateParams?.distributors || []).length;

  const parseDistributorInfo = (): ProductCardDistributorInfo => {
    // If there's only one dual distributor, we will consider them the matched distributor
    const dualDistributor =
      productLineDualDistributors?.length == 1 && productLineDualDistributors[0];
    const distributorId =
      dualDistributor?.id || get(productLine, "distributor_info.distributor_id");

    const name = dualDistributor?.name || get(productLine, "distributor_info.distributor_name");
    const integrated = distributorIsIntegrated(
      dualDistributor,
      get(productLine, "distributor_info"),
    );

    return { name, integrated, id: distributorId };
  };

  const overrideInfo = distributorOverride ? { integrated: false, ...distributorOverride } : null;
  const distributorInfo = overrideInfo || parseDistributorInfo();

  const hasMultipleDualDistributors = productLineDualDistributors?.length > 1;
</script>

<style>
  .fizz-tooltip-container {
    width: auto;
  }
  .fizz-tooltip-trigger {
    font-weight: normal;
    white-space: break-spaces;
  }
  .fizz-tooltip {
    text-align: center;
    width: 100%;
  }
  .fizz-truncate {
    --max-width: 90%;
  }
  .no-distributor-selected {
    color: #1b1b1b;
  }
</style>

{#if !hideDistributor && hasMultipleDualDistributors}
  <div data-testid="product-card-distributor">
    <div class="fizz-tooltip-container" data-testid="product-card-dual-distributors-tooltip">
      <button class="fizz-tooltip-trigger" aria-describedby="tooltip-desc2">
        <span class="fizz-text-medium fizz-text-subdued fizz-underline-dashed"
          >Sold by multiple distributors</span
        >
      </button>
      <div
        class="fizz-tooltip fizz-tooltip-center {extraTooltipClass}"
        role="tooltip"
        id="tooltip-desc2"
      >
        {#each productLineDualDistributors as distributor}
          <div>{distributor.name}</div>
        {/each}
      </div>
    </div>
  </div>
{:else if !hideDistributor && distributorInfo}
  <div data-testid="product-card-distributor">
    {#if !!distributorInfo.name}
      {#if clickable}
        <DistributorLink
          distributor={distributorInfo}
          extraTextClasses={clickableTextClass}
          useTrackClick={true}
          {targetObjectType}
        />
      {:else}
        <DistributorName
          distributor={{ integrated: distributorInfo.integrated, name: distributorInfo.name }}
        />
      {/if}
    {:else}
      <div
        class="fizz-text-medium no-distributor-selected"
        data-testid="product-card-no-distributor-selected"
      >
        Select Distributor on product detail
      </div>
    {/if}
  </div>
{/if}
